export const ROUTER = {
  HOME_PAGE_ROUTE: "/",
  WATCHES_PAGE_ROUTE: "/watches",
  BELTS_PAGE_ROUTE: "/belts",
  BELTS_SINGLE_PAGE_ROUTE: "/belts/:id",
  ABOUTUS_PAGE_ROUTE: "/aboutus",
  GARUANTEE_PAGE_ROUTE: "/garuantee",
  CONTACTUS_PAGE_ROUTE: "/contactus",
  SINGLE_WATCH_PAGE_ROUTE: "/watches/:id",
  CHECKOUT_PAGE_ROUTE: "/checkout",
  DELIVERY_PAGE_ROUTE: "/delivery_terms",
  ERROR_PAGE_ROUTE: "*",
};
